{
  "name": "open-rmbt-angular",
  "version": "0.0.0",
  "scripts": {
    "compile-deps-info": "npx ts-node scripts/compile-deps-info.ts",
    "generate-sitemap": "npx ts-node scripts/prepare-routes-for-sitemap.ts && npx ts-node scripts/generate-sitemap.ts",
    "ng": "ng",
    "start": "concurrently \"node proxy\" \"ng serve\"",
    "start:prod": "ng build && npx lite-server --baseDir=dist/open-rmbt-angular/browser",
    "start:stage": "ng serve --configuration=stage",
    "start:preprod": "ng serve --configuration=preprod",
    "build": "ng build",
    "build:preprod": "ng build --configuration=preprod",
    "build:stage": "ng build --configuration=stage",
    "build:dev3": "ng build --configuration=dev3",
    "build:dev": "ng build --configuration=dev",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "set-prerender-routes": "npx ts-node scripts/set-prerender-routes.ts",
    "prepare": "husky",
    "preinstall": "git submodule init && git submodule update",
    "prestart": "node scripts/set-package-info.js",
    "prebuild": "node scripts/set-package-info.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.2",
    "@angular/cdk": "^21.2.2",
    "@angular/common": "^21.2.2",
    "@angular/compiler": "^21.2.2",
    "@angular/core": "^21.2.2",
    "@angular/forms": "^21.2.2",
    "@angular/material": "^21.2.2",
    "@angular/platform-browser": "^21.2.2",
    "@angular/platform-browser-dynamic": "^21.2.2",
    "@angular/platform-server": "^21.2.2",
    "@angular/router": "^21.2.2",
    "@angular/ssr": "^21.2.2",
    "@turf/bbox": "^7.1.0",
    "@turf/circle": "^7.2.0",
    "@turf/helpers": "^7.1.0",
    "browser-image-compression": "^2.0.2",
    "chart.js": "^4.4.6",
    "chartjs-adapter-dayjs-4": "^1.0.4",
    "dayjs": "^1.11.13",
    "express": "^4.18.2",
    "file-saver": "^2.0.5",
    "formatcoords": "^1.1.3",
    "js-cookie": "^3.0.5",
    "maplibre-gl": "^5.7.2",
    "material-icons": "^1.13.12",
    "material-symbols": "^0.27.0",
    "ngx-matomo-client": "^9.0.1",
    "ol": "^10.4.0",
    "rmbtws": "./rmbtws",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.0.3",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.2",
    "@angular/cli": "^21.2.2",
    "@angular/compiler-cli": "^21.2.2",
    "@types/express": "^4.17.17",
    "@types/file-saver": "^2.0.7",
    "@types/formatcoords": "^1.1.2",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~5.1.0",
    "@types/js-cookie": "^3.0.6",
    "@types/node": "^18.18.0",
    "baseline-browser-mapping": "^2.9.19",
    "concurrently": "^9.2.1",
    "http-proxy-middleware": "^3.0.5",
    "husky": "^9.1.7",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  },
  "gitInfo": {
    "hash": "220bdb32933024d128bac585792e646914e32449",
    "branch": "main"
  }
}